import * as React from 'react';
import * as _ from 'underscore';

import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';

import { Helpers } from '../../../ts/helpers/Helpers';
import { postLoginNotification } from '../../../zeus/PostLoginNotification';
import { useIsMounted } from '../../hooks';
import { UrlParamKeys } from '../../UrlParamKeys';

export const ProcessAndRemoveSamlQueryWrapper: React.FunctionComponent<{}> = props => {
  const isMounted = useIsMounted();
  if (!isMounted) {
    const search: any = WindowLocationService.getHashQueryObject();
    if (_.has(search, UrlParamKeys.IsFromSaml)) {
      if (Helpers.BooleanQueryParamRegex.test(search[UrlParamKeys.IsFromSaml])) {
        if (postLoginNotification) {
          postLoginNotification.enableNotifications();
        }
      }

      WindowLocationService.deleteQueryParameter(UrlParamKeys.IsFromSaml);
    }
  }

  return <>{props.children}</>;
};
